import { BaseEntity } from '../../xform-compat';
import { DateTime } from 'luxon';

/**
 * Model Schema for Holiday
 */
export class Holiday implements BaseEntity {
  id: number;
  description: string;
  holidayDate: string;
  holidayDateUI: any;

  constructor (holiday: any = {}) {
    this.id = holiday.id || null;
    this.description = holiday.description || '';
    this.holidayDate = holiday.holidayDate || null;
    this.holidayDateUI = DateTime.fromISO(holiday.holidayDate) || null;
  }
}
